import { useJbHttpCrudService } from "../../core/service/jb-http-crud.service";
import { AttendanceStepTypeEntity } from "../../context/admin/module/attendance/domain/entity/attendance-step-type.entity";

export function useAttendanceStepTypeRepository() {
  const crud = useJbHttpCrudService<AttendanceStepTypeEntity>('step-type');
  return {
    ...crud
  }
}
